import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import LineChart from './LineChart';
import LineChartCostRevovery from './LineChartCostRevovery';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import ModelInfo from './ModelInfo';
const FireSuppressionCalculator = () => {
    const { t, i18n } = useTranslation();
    const [languageCounter, setLanguageCounter] = useState(0);

    // Separate states for each parameter in both systems
    const [btConcentrate, setBtConcentrate] = useState("0");
    const [fdConcentrate, setFdConcentrate] = useState("0");

    const [btExtinguishingTime, setBtExtinguishingTime] = useState("0");
    const [fdExtinguishingTime, setFdExtinguishingTime] = useState("0");

    const [btWaterFlow, setBtWaterFlow] = useState("0");
    const [fdWaterFlow, setFdWaterFlow] = useState("0");

    const [btProportioningTestTime, setBtProportioningTestTime] = useState("0");
    const [fdProportioningTestTime, setFdProportioningTestTime] = useState("0");

    const [btpersonnelRequired, setBtpersonnelRequired] = useState("0");
    const [fdpersonnelRequired, setFdpersonnelRequired] = useState("0");

    const [btworkTime, setBtworkTime] = useState("0");
    const [fdworkTime, setFdworkTime] = useState("0");

    const [btlaborCost, setBtlaborCost] = useState("0");
    const [fdlaborCost, setFdlaborCost] = useState("0");
  
    const [btconCentrateCost, setBtConcentrateCost] = useState(0);
    const [fdconCentrateCost, setFdConcentrateCost] = useState(0);

    const [btPremix, setBtpremix] = useState("0");
    const [fdPremix, setFdpremix] = useState("0");

    const [btRegularMaintenance, setBtregularMaintenance] = useState("0");
    const [fdRegularMaintenance, setFdregularMaintenance] = useState("0");

    const [btTankSizeNeeded, seRBtTankSizeNeeded] = useState("0");
    const [fdTankSizeNeeded, seRFdTankSizeNeeded] = useState("0");

    const [btFoamTank, setBtFoamTank] = useState("0");
    const [fdFoamTank, setFdFoamTank] = useState("0");

    const [btTankProportioner, seTBttankProportioner] = useState("0");
    const [fdTankProportioner, seTFdtankProportioner] = useState("0");

    const [btfirFdosProportioner, seTBtFiredosProportioner] = useState("0");
    const [fdfiredosProportioner, seTFdFiredosProportioner] = useState("0");

    const [btInitialFoamInvestment, setBtInitialFoamInvestment] = useState(0);
    const [fdInitialFoamInvestment, setFdInitialFoamInvestment] = useState(0);

    const [btConcentrateUsedPerTest, setBtConcentrateUsedPerTest] = useState(0);
    const [fdConcentrateUsedPerTest, setFdConcentrateUsedPerTest] = useState(0);

    const [btPremixGeneratedPerTest, setBtPremixGeneratedPerTest] = useState(0);
    const [fdPremixGeneratedPerTest, setFdPremixGeneratedPerTest] = useState(0);

    const [btConcentrateCostPerTest, setBtConcentrateCostPerTest] = useState(0);
    const [fdConcentrateCostPerTest, setFdConcentrateCostPerTest] = useState(0);

    const [btPremixDisposalCostPerTest, setBtPremixDisposalCostPerTest] = useState(0);
    const [fdPremixDisposalCostPerTest, setFdPremixDisposalCostPerTest] = useState(0);

    const [btWorkCostPerTest, setBtWorkCostPerTest] = useState(0);
    const [fdWorkCostPerTest, setFdWorkCostPerTest] = useState(0);

    const [btTotalCostOfProportioningRateTest, setBtTotalCostOfProportioningRateTest] = useState(0);
    const [fdTotalCostOfProportioningRateTest, setFdTotalCostOfProportioningRateTest] = useState(0);

    const [btTotalCostOfOperationInitialInvestmentCost, setBtTotalCostOfOperationInitialInvestmentCost] = useState(0);
    const [fdTotalCostOfOperationInitialInvestmentCost, setFdTotalCostOfOperationInitialInvestmentCost] = useState(0);

    const [btTotalCostOfOperationCostOfProportioningRateTest, setBtTotalCostOfOperationCostOfProportioningRateTest] = useState(0);
    const [fdTotalCostOfOperationCostOfProportioningRateTest, setFdTotalCostOfOperationCostOfProportioningRateTest] = useState(0);

    const [btTotalCostOfOperation5YearTotalCostOfOperation, setBtTotalCostOfOperation5YearTotalCostOfOperation] = useState(0);
    const [fdTotalCostOfOperation5YearTotalCostOfOperation, setFdTotalCostOfOperation5YearTotalCostOfOperation] = useState(0);

    const [chartBladderTankZeroYear, setChartBladderTankZeroYear] = useState(0)
    const [chartFireDosZeroYear, setChartFireDosZeroYear] = useState(0)

    const [chartBladderTankFirstYear, setChartBladderTankFirstYear] = useState(0)
    const [chartFireDosFirstYear, setChartFireDosFirstYear] = useState(0)

    const [chartBladderTankSecondYear, setChartBladderTankSecondYear] = useState(0)
    const [chartFireDosSecondYear, setChartFireDosSecondYear] = useState(0)

    const [chartBladderTankThirdYear, setChartBladderTankThirdYear] = useState(0)
    const [chartFireDosThirdYear, setChartFireDosThirdYear] = useState(0)

    const [chartBladderTankFour, setChartBladderTankFour] = useState(0)
    const [chartFireDosFour, setChartFireDosFour] = useState(0)

    const [chartBladderTankFive, setChartBladderTankFive] = useState(0)
    const [chartFireDosFive, setChartFireDosFive] = useState(0)

    // Second Chart Data
    const [chartSecondDiffZeroYear, setChartSecondDiffZeroYear] = useState(0)
    const [chartSecondPercentageZeroYear, setChartSecondPercentageZeroYear] = useState(0)

    const [chartSecondDiffFirstYear, setChartSecondDiffFirstYear] = useState(0)
    const [chartSecondPercentageFirstYear, setChartSecondPercentageFirstYear] = useState(0)

    const [chartSecondDiffSecondYear, setChartSecondDiffSecondYear] = useState(0)
    const [chartSecondPercentageSecondYear, setChartSecondPercentageSecondYear] = useState(0)

    const [chartSecondDiffThirdYear, setChartSecondDiffThirdYear] = useState(0)
    const [chartSecondPercentageThirdYear, setChartSecondPercentageThirdYear] = useState(0)

    const [chartSecondDiffFour, setChartSecondDiffFour] = useState(0)
    const [chartSecondPercentageFour, setChartSecondPercentageFour] = useState(0)

    const [chartSecondDiffFive, setChartSecondDiffFive] = useState(0)
    const [chartSecondPercentageFive, setChartSecondPercentageFive] = useState(0)

    const [firstChartArrayData, setFirstChartArrayData] = useState({
        bt: [],
        fd: []
    })
    const [secondchartArrayData, setSecondchartArrayData] = useState([])
 
    const convertNumberForCalculation = (number) => {
        if(typeof number === 'number') {
            number = number.toString()
        }
        if(number.length >= 7) {
            return parseFloat(number);
        }
        if(selectLangues === "en") {
            if(number.includes(",") && number.length <= 4) {
                number = number.replaceAll(",", ".")
            }
            number = number.replaceAll(",", "")
        }
        else {
            if(number.includes(".") && number.length <= 4) {
                number = number.replaceAll(".", ".")
            }
            else {
                number = number.replaceAll(".", "")
                number = number.replaceAll(",", ".")
            } 
        }
        return parseFloat(number);
    }
    
    const convertNumberForChangeLanguage = (number) => {
        if(typeof number === 'number') {
            number = number.toString()
        }
        if(number.length >= 7) {
            return parseFloat(number);
        }
        if((number.includes(",") || number.includes(".")) && number.length <= 4) {
            return number;
        }
        if(selectLangues === "en") {
            number = number.replaceAll(".", "")
            number = number.replaceAll(",", ".")
        }
        else {
            number = number.replaceAll(",", ".");
        }
        const plainNumber = number;
        const decimalNumber = plainNumber.split(".");
        
        // Convert to string for formatting
        const reversedInt = decimalNumber[0].split('').reverse();
    
        // Add dots (.) every three digits
        const formattedInt = reversedInt.reduce((acc, digit, index) => {
            if (index !== 0 && index % 3 === 0) {
                if (selectLangues === "de") {
                    acc.push('.');
                }
                else {
                    acc.push(',');
                }
            }
            acc.push(digit);
            return acc;
        }, []).reverse().join('');
    
        // Return the formatted number
        if(decimalNumber.length === 1) {
            return formattedInt;
        }
        if (selectLangues === "en") {
            return formattedInt + "," + decimalNumber[1];
        }
        else {
            return formattedInt + "." + decimalNumber[1];
        }
        return number;
    }

    const convertNumberForChangeTab = (number) => {
        if(typeof number === 'number') {
            number = number.toString()
        }
        if(number.startsWith(".") || number.startsWith(",")) {
            return "0" + number;
        }
        if(number.length >= 7) {
            return parseFloat(number);
        }
        if((number.includes(",") || number.includes(".")) && number.length <= 4) {
            return number;
        }
        if(selectLangues === "en") {
            number = number.replaceAll(",", "");
        }
        else {
            number = number.replaceAll(".", "")
            number = number.replaceAll(",", ".")
        }
        const plainNumber = number;
        const decimalNumber = plainNumber.split(".");
        
        // Convert to string for formatting
        const reversedInt = decimalNumber[0].split('').reverse();
    
        // Add dots (.) every three digits
        const formattedInt = reversedInt.reduce((acc, digit, index) => {
            if (index !== 0 && index % 3 === 0) {
                if (selectLangues === "de") {
                    acc.push('.');
                }
                else {
                    acc.push(',');
                }
            }
            acc.push(digit);
            return acc;
        }, []).reverse().join('');
    
        // Return the formatted number
        if(decimalNumber.length === 1) {
            return formattedInt;
        }
        if (selectLangues === "en") {
            return formattedInt + "," + decimalNumber[1];
        }
        else {
            return formattedInt + "." + decimalNumber[1];
        }
        return number;
    }

    const [selectLangues, setSelectLangues] = useState("en")
    useEffect(() => {
        setBtInitialFoamInvestment(convertNumberForCalculation(btconCentrateCost) * convertNumberForCalculation(btTankSizeNeeded))
        setFdInitialFoamInvestment(convertNumberForCalculation(fdconCentrateCost) * convertNumberForCalculation(fdTankSizeNeeded))

        setBtConcentrateUsedPerTest((convertNumberForCalculation(btWaterFlow) * (convertNumberForCalculation(btConcentrate) / 100)) * convertNumberForCalculation(btProportioningTestTime))
        setFdConcentrateUsedPerTest(0)

        setBtPremixGeneratedPerTest((convertNumberForCalculation(btWaterFlow) * convertNumberForCalculation(btProportioningTestTime)) + convertNumberForCalculation(btConcentrateUsedPerTest))
        setFdPremixGeneratedPerTest(0)

        setBtConcentrateCostPerTest(convertNumberForCalculation(btconCentrateCost) * convertNumberForCalculation(btConcentrateUsedPerTest))
        setFdConcentrateCostPerTest(0)

        setBtPremixDisposalCostPerTest(convertNumberForCalculation(btPremixGeneratedPerTest) * convertNumberForCalculation(btPremix))
        setFdPremixDisposalCostPerTest(0)

        setBtWorkCostPerTest(convertNumberForCalculation(btpersonnelRequired) * convertNumberForCalculation(btworkTime) * convertNumberForCalculation(btlaborCost))
        setFdWorkCostPerTest(convertNumberForCalculation(fdpersonnelRequired) * convertNumberForCalculation(fdworkTime) * convertNumberForCalculation(fdlaborCost))

        setBtTotalCostOfProportioningRateTest(convertNumberForCalculation(btConcentrateCostPerTest) + convertNumberForCalculation(btPremixDisposalCostPerTest) + convertNumberForCalculation(btWorkCostPerTest))
        setFdTotalCostOfProportioningRateTest(convertNumberForCalculation(fdConcentrateCostPerTest) + convertNumberForCalculation(fdPremixDisposalCostPerTest) + convertNumberForCalculation(fdWorkCostPerTest))

        setChartBladderTankZeroYear(
            convertNumberForCalculation(btFoamTank) +
            convertNumberForCalculation(btTankProportioner) + 0 *
            (convertNumberForCalculation(btTotalCostOfProportioningRateTest) + convertNumberForCalculation(btRegularMaintenance)) +
            convertNumberForCalculation(btInitialFoamInvestment)
        )
        setChartFireDosZeroYear(
            convertNumberForCalculation(fdfiredosProportioner) + 0 *
            (convertNumberForCalculation(fdTotalCostOfProportioningRateTest) + convertNumberForCalculation(fdRegularMaintenance)) +
            convertNumberForCalculation(fdInitialFoamInvestment)
        )

        setChartBladderTankFirstYear(convertNumberForCalculation(chartBladderTankZeroYear) + convertNumberForCalculation(btTotalCostOfProportioningRateTest) + convertNumberForCalculation(btRegularMaintenance))
        setChartFireDosFirstYear(convertNumberForCalculation(chartFireDosZeroYear) + convertNumberForCalculation(fdTotalCostOfProportioningRateTest) + convertNumberForCalculation(fdRegularMaintenance))

        setChartBladderTankSecondYear(convertNumberForCalculation(chartBladderTankFirstYear) + convertNumberForCalculation(btTotalCostOfProportioningRateTest) + convertNumberForCalculation(btRegularMaintenance))
        setChartFireDosSecondYear(convertNumberForCalculation(chartFireDosFirstYear) + convertNumberForCalculation(fdTotalCostOfProportioningRateTest) + convertNumberForCalculation(fdRegularMaintenance))

        setChartBladderTankThirdYear(convertNumberForCalculation(chartBladderTankSecondYear) + convertNumberForCalculation(btTotalCostOfProportioningRateTest) + convertNumberForCalculation(btRegularMaintenance))
        setChartFireDosThirdYear(convertNumberForCalculation(chartFireDosSecondYear) + convertNumberForCalculation(fdTotalCostOfProportioningRateTest) + convertNumberForCalculation(fdRegularMaintenance))

        setChartBladderTankFour(convertNumberForCalculation(chartBladderTankThirdYear) + convertNumberForCalculation(btTotalCostOfProportioningRateTest) + convertNumberForCalculation(btRegularMaintenance))
        setChartFireDosFour(convertNumberForCalculation(chartFireDosThirdYear) + convertNumberForCalculation(fdTotalCostOfProportioningRateTest) + convertNumberForCalculation(fdRegularMaintenance))

        setChartBladderTankFive(convertNumberForCalculation(chartBladderTankFour) + convertNumberForCalculation(btTotalCostOfProportioningRateTest) + convertNumberForCalculation(btRegularMaintenance))
        setChartFireDosFive(convertNumberForCalculation(chartFireDosFour) + convertNumberForCalculation(fdTotalCostOfProportioningRateTest) + convertNumberForCalculation(fdRegularMaintenance))

        setBtTotalCostOfOperationInitialInvestmentCost(chartBladderTankZeroYear)
        setFdTotalCostOfOperationInitialInvestmentCost(chartFireDosZeroYear)

        setBtTotalCostOfOperationCostOfProportioningRateTest(btTotalCostOfProportioningRateTest)
        setFdTotalCostOfOperationCostOfProportioningRateTest(fdTotalCostOfProportioningRateTest)

        setBtTotalCostOfOperation5YearTotalCostOfOperation(chartBladderTankFive)
        setFdTotalCostOfOperation5YearTotalCostOfOperation(chartFireDosFive)

        setChartSecondDiffZeroYear(convertNumberForCalculation(chartBladderTankZeroYear) - convertNumberForCalculation(chartFireDosZeroYear))
        setChartSecondDiffFirstYear(convertNumberForCalculation(chartBladderTankFirstYear) - convertNumberForCalculation(chartFireDosFirstYear))
        setChartSecondDiffSecondYear(convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear))
        setChartSecondDiffThirdYear(convertNumberForCalculation(chartBladderTankThirdYear) - convertNumberForCalculation(chartFireDosThirdYear))
        setChartSecondDiffFour(convertNumberForCalculation(chartBladderTankFour) - convertNumberForCalculation(chartFireDosFour))
        setChartSecondDiffFive(convertNumberForCalculation(chartBladderTankFive) - convertNumberForCalculation(chartFireDosFive))

        setChartSecondPercentageZeroYear(Math.round(((convertNumberForCalculation(chartBladderTankZeroYear) - convertNumberForCalculation(chartFireDosZeroYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageFirstYear(Math.round(((convertNumberForCalculation(chartBladderTankFirstYear) - convertNumberForCalculation(chartFireDosFirstYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageSecondYear(Math.round(((convertNumberForCalculation(chartBladderTankSecondYear) - convertNumberForCalculation(chartFireDosSecondYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageThirdYear(Math.round(((convertNumberForCalculation(chartBladderTankThirdYear) - convertNumberForCalculation(chartFireDosThirdYear)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageFour(Math.round(((convertNumberForCalculation(chartBladderTankFour) - convertNumberForCalculation(chartFireDosFour)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))
        setChartSecondPercentageFive(Math.round(((convertNumberForCalculation(chartBladderTankFive) - convertNumberForCalculation(chartFireDosFive)) / convertNumberForCalculation(chartFireDosZeroYear)) * 100))

        setFirstChartArrayData(
            {
                bt: [
                    chartBladderTankZeroYear,
                    chartBladderTankFirstYear,
                    chartBladderTankSecondYear,
                    chartBladderTankThirdYear,
                    chartBladderTankFour,
                    chartBladderTankFive
                ],
                fd: [
                    chartFireDosZeroYear,
                    chartFireDosFirstYear,
                    chartFireDosSecondYear,
                    chartFireDosThirdYear,
                    chartFireDosFour,
                    chartFireDosFive
                ]
            })

        setSecondchartArrayData([chartSecondPercentageZeroYear,
            chartSecondPercentageFirstYear,
            chartSecondPercentageSecondYear,
            chartSecondPercentageThirdYear,
            chartSecondPercentageFour,
            chartSecondPercentageFive
        ]);

        seRBtTankSizeNeeded((convertNumberForCalculation(btExtinguishingTime) * convertNumberForCalculation(btWaterFlow)) / 100 * convertNumberForCalculation(btConcentrate));
        seRFdTankSizeNeeded((convertNumberForCalculation(fdExtinguishingTime) * convertNumberForCalculation(fdWaterFlow)) / 100 * convertNumberForCalculation(fdConcentrate));

    }, [
        selectLangues,
        btConcentrate,
        fdConcentrate,
        btExtinguishingTime,
        fdExtinguishingTime,
        btWaterFlow,
        fdWaterFlow,
        btProportioningTestTime,
        fdProportioningTestTime,
        btpersonnelRequired,
        fdpersonnelRequired,
        btworkTime,
        fdworkTime,
        btlaborCost,
        fdlaborCost,
        btconCentrateCost,
        fdconCentrateCost,
        btPremix,
        fdPremix,
        btRegularMaintenance,
        fdRegularMaintenance,
        btTankSizeNeeded,
        fdTankSizeNeeded,
        btFoamTank,
        fdFoamTank,
        btTankProportioner,
        fdTankProportioner,
        btfirFdosProportioner,
        fdfiredosProportioner,
        btInitialFoamInvestment,
        fdInitialFoamInvestment,
        btConcentrateUsedPerTest,
        fdConcentrateUsedPerTest,
        btPremixGeneratedPerTest,
        fdPremixGeneratedPerTest,
        btConcentrateCostPerTest,
        fdConcentrateCostPerTest,
        btPremixDisposalCostPerTest,
        fdPremixDisposalCostPerTest,
        btWorkCostPerTest,
        fdWorkCostPerTest,
        btTotalCostOfProportioningRateTest,
        fdTotalCostOfProportioningRateTest,
        btTotalCostOfOperationInitialInvestmentCost,
        fdTotalCostOfOperationInitialInvestmentCost,
        btTotalCostOfOperationCostOfProportioningRateTest,
        fdTotalCostOfOperationCostOfProportioningRateTest,
        btTotalCostOfOperation5YearTotalCostOfOperation,
        fdTotalCostOfOperation5YearTotalCostOfOperation,
        chartBladderTankZeroYear,
        chartFireDosZeroYear,
        chartBladderTankFirstYear,
        chartFireDosFirstYear,
        chartBladderTankSecondYear,
        chartFireDosSecondYear,
        chartBladderTankThirdYear,
        chartFireDosThirdYear,
        chartBladderTankFour,
        chartFireDosFour,
        chartBladderTankFive,
        chartFireDosFive,
        chartSecondDiffZeroYear,
        chartSecondPercentageZeroYear,
        chartSecondDiffFirstYear,
        chartSecondPercentageFirstYear,
        chartSecondDiffSecondYear,
        chartSecondPercentageSecondYear,
        chartSecondDiffThirdYear,
        chartSecondPercentageThirdYear,
        chartSecondDiffFour,
        chartSecondPercentageFour,
        chartSecondDiffFive,
        chartSecondPercentageFive,
    ])
    const [activeKey, setActiveKey] = useState("0");
    const contentRef = useRef();

    const handleToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };
    function formatIndianNumber(number) {
        if (isNaN(number)) {
            return "0";
        }
    
        // Remove commas and parse the input as a number
        const plainNumber = number.toString().replace(/,/g, '');
        const decimalNumber = plainNumber.split(".");
        
        // Convert to string for formatting
        const reversedInt = decimalNumber[0].split('').reverse();
    
        // Add dots (.) every three digits
        const formattedInt = reversedInt.reduce((acc, digit, index) => {
            if (index !== 0 && index % 3 === 0) {
                if (selectLangues === "de") {
                    acc.push('.');
                }
                else {
                    acc.push(',');
                }
            }
            acc.push(digit);
            return acc;
        }, []).reverse().join('');
    
        // Return the formatted number
        if(decimalNumber.length === 1) {
            return formattedInt;
        }
        if (selectLangues === "en") {
            return formattedInt + "." + decimalNumber[1].slice(0, 2);
        }
        else {
            return formattedInt + "," + decimalNumber[1].slice(0, 2);
        }
    }
     
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const paramValue = queryParams.get("lang");
        if(paramValue?.toLowerCase() === "en" || paramValue?.toLowerCase() === "de") {
            changeLanguage(paramValue);
            if(paramValue?.toLowerCase() === "de") {
                setFdworkTime("0");
                setBtpremix("0");
                setFdpremix("0");
                setBtWaterFlow("0");
                setFdWaterFlow("0");
                setBtregularMaintenance("0");
                setFdregularMaintenance("0");
                setBtFoamTank("0");
                setFdFoamTank("0");
                seTBttankProportioner("0");
                seTFdFiredosProportioner("0");
                seTFdFiredosProportioner("0");
            }
        }
    }, [])
  
    useEffect(() => {
        if(languageCounter) {
            if(selectLangues === "en") {
                setBtConcentrate(convertNumberForChangeLanguage(btConcentrate));
                setFdConcentrate(convertNumberForChangeLanguage(fdConcentrate));
                setBtExtinguishingTime(convertNumberForChangeLanguage(btExtinguishingTime));
                setFdExtinguishingTime(convertNumberForChangeLanguage(fdExtinguishingTime));
                setBtWaterFlow(convertNumberForChangeLanguage(btWaterFlow));
                setFdWaterFlow(convertNumberForChangeLanguage(fdWaterFlow));
                setBtProportioningTestTime(convertNumberForChangeLanguage(btProportioningTestTime));
                setFdProportioningTestTime(convertNumberForChangeLanguage(fdProportioningTestTime));
                setBtpersonnelRequired(convertNumberForChangeLanguage(btpersonnelRequired));
                setFdpersonnelRequired(convertNumberForChangeLanguage(fdpersonnelRequired));
                setBtworkTime(convertNumberForChangeLanguage(btworkTime));
                setFdworkTime(convertNumberForChangeLanguage(fdworkTime));
                setBtlaborCost(convertNumberForChangeLanguage(btlaborCost));
                setFdlaborCost(convertNumberForChangeLanguage(fdlaborCost));
                setBtConcentrateCost(convertNumberForChangeLanguage(btconCentrateCost));
                setFdConcentrateCost(convertNumberForChangeLanguage(fdconCentrateCost));
                setBtpremix(convertNumberForChangeLanguage(btPremix));
                setFdpremix(convertNumberForChangeLanguage(fdPremix));
                setBtregularMaintenance(convertNumberForChangeLanguage(btRegularMaintenance));
                setFdregularMaintenance(convertNumberForChangeLanguage(fdRegularMaintenance));
                setBtFoamTank(convertNumberForChangeLanguage(btFoamTank));
                setFdFoamTank(convertNumberForChangeLanguage(fdFoamTank));
                seTBttankProportioner(convertNumberForChangeLanguage(btTankProportioner));
                seTFdtankProportioner(convertNumberForChangeLanguage(fdTankProportioner));
                seTBtFiredosProportioner(convertNumberForChangeLanguage(btfirFdosProportioner));
                seTFdFiredosProportioner(convertNumberForChangeLanguage(fdfiredosProportioner));
            }
            else {
                setBtConcentrate(convertNumberForChangeLanguage(btConcentrate));
                setFdConcentrate(convertNumberForChangeLanguage(fdConcentrate));
                setBtExtinguishingTime(convertNumberForChangeLanguage(btExtinguishingTime));
                setFdExtinguishingTime(convertNumberForChangeLanguage(fdExtinguishingTime));
                setBtWaterFlow(convertNumberForChangeLanguage(btWaterFlow));
                setFdWaterFlow(convertNumberForChangeLanguage(fdWaterFlow));
                setBtProportioningTestTime(convertNumberForChangeLanguage(btProportioningTestTime));
                setFdProportioningTestTime(convertNumberForChangeLanguage(fdProportioningTestTime));
                setBtpersonnelRequired(convertNumberForChangeLanguage(btpersonnelRequired));
                setFdpersonnelRequired(convertNumberForChangeLanguage(fdpersonnelRequired));
                setBtworkTime(convertNumberForChangeLanguage(btworkTime));
                setFdworkTime(convertNumberForChangeLanguage(fdworkTime));
                setBtlaborCost(convertNumberForChangeLanguage(btlaborCost));
                setFdlaborCost(convertNumberForChangeLanguage(fdlaborCost));
                setBtConcentrateCost(convertNumberForChangeLanguage(btconCentrateCost));
                setFdConcentrateCost(convertNumberForChangeLanguage(fdconCentrateCost));
                setBtpremix(convertNumberForChangeLanguage(btPremix));
                setFdpremix(convertNumberForChangeLanguage(fdPremix));
                setBtregularMaintenance(convertNumberForChangeLanguage(btRegularMaintenance));
                setFdregularMaintenance(convertNumberForChangeLanguage(fdRegularMaintenance));
                setBtFoamTank(convertNumberForChangeLanguage(btFoamTank));
                setFdFoamTank(convertNumberForChangeLanguage(fdFoamTank));
                seTBttankProportioner(convertNumberForChangeLanguage(btTankProportioner));
                seTFdtankProportioner(convertNumberForChangeLanguage(fdTankProportioner));
                seTBtFiredosProportioner(convertNumberForChangeLanguage(btfirFdosProportioner));
                seTFdFiredosProportioner(convertNumberForChangeLanguage(fdfiredosProportioner));
            }
        }
    }, [languageCounter])

    const changeLanguage = (lng) => {
        setSelectLangues(lng)
        i18n.changeLanguage(lng); // Switch language
    };
    const chartRef = useRef(null);
    const chartRef2 = useRef(null);


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const generatePDF = async () => {

        const logo = "/firedos-logo.png";
        const imageX = 165;
        const imageY = 10;
        const imageWidth = 35; // Set your image width
        const imageHeight = 7; // Set your image height

        const doc = new jsPDF();
  
        // Add header
        doc.setFillColor(40, 50, 55); // Dark header color
        const headerHeight = imageHeight + 19.5; // Adjust height if needed
        doc.rect(0, imageY - 10, doc.internal.pageSize.width, headerHeight, "F");

        // Add logo
        doc.addImage(logo, "PNG", imageX, imageY, imageWidth, imageHeight);

        // Add title
        let textY = imageY + imageHeight + 5;
        doc.setFontSize(12); // Title font size
        doc.setFont("helvetica", "bold");
        const title = t("FIRE SUPPRESSION SYSTEM CALCULATOR");
        const titleWidth = doc.getTextWidth(title);
        const pageWidth = doc.internal.pageSize.width;
        const titleX = (pageWidth - titleWidth) / 2; // Centering the title
        doc.text(title, titleX, textY + 15); // Position the title centered at the top

        // Add footer for the first page
        const pageHeight = doc.internal.pageSize.height;
        const footerHeight = 18; // Height of the footer
        const footerColor = [232, 232, 232]; // RGB color for footer

        // Footer background (First Page)
        doc.setFillColor(...footerColor);
        doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");

        // Footer text (First Page)
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "bold");

        if (selectLangues === "en") {

            doc.text([
                "www.firedos.com"
            ], 160, pageHeight - 5,);
        } else {
            doc.text([
                "www.firedos.de",
            ], 160, pageHeight - 5,);
        }

        // Define tables data and structure
        const tables = [
            {
                title: t("System Parameters"),
                columns: [t("Parameter"), "Bladder Tank", 'FireDos', t("Unit")],
                data: [
                    [t("rate"), formatIndianNumber(btConcentrate), formatIndianNumber(fdConcentrate), "%"],
                    [t("Extinguishing time"), formatIndianNumber(btExtinguishingTime), formatIndianNumber(fdExtinguishingTime), t("min")],
                    [t("Water flow"), formatIndianNumber(btWaterFlow), formatIndianNumber(fdWaterFlow), t("gal/min")],
                    [t("Proportioning test time"), formatIndianNumber(btProportioningTestTime), formatIndianNumber(fdProportioningTestTime), t("min")],
                    [t("Personnel required for proportioning test"), formatIndianNumber(btpersonnelRequired), formatIndianNumber(fdpersonnelRequired), t("ea")],
                    [t("Work time proportioning test"), formatIndianNumber(btworkTime), formatIndianNumber(fdworkTime), t("hour")],
                    [t("Labor cost"), formatIndianNumber(btlaborCost), formatIndianNumber(fdlaborCost), t("$")],
                    [t("Concentrate cost"), formatIndianNumber(btconCentrateCost), formatIndianNumber(fdconCentrateCost), t("$/Gal")],
                    [t("Premix disposal cost"), formatIndianNumber(btPremix), formatIndianNumber(fdPremix), t("$") + "/" + t("Gal")],
                    [t("Annual regular maintenance cost"), formatIndianNumber(btRegularMaintenance), formatIndianNumber(fdRegularMaintenance), t("$")],
                    [t("Bladder / foam tank size needed"), formatIndianNumber(btTankSizeNeeded), formatIndianNumber(fdTankSizeNeeded), t("gal")],
                    [t("Cost bladder / foam tank"), formatIndianNumber(btFoamTank), formatIndianNumber(fdFoamTank), t("$")],
                    [t("One-off cost bladder tank proportioner"), formatIndianNumber(btTankProportioner), formatIndianNumber(fdTankProportioner), t("$")],
                    [t("One-off Cost firedos proportioner"), formatIndianNumber(btfirFdosProportioner), formatIndianNumber(fdfiredosProportioner), t("$")],
                ]
            },
            {
                title: t("Test Costs - Detailed View"),
                columns: [t("Cost Item"), "Bladder Tank", 'FireDos', t("Unit")],
                data: [
                    [t("Initial foam investment"), formatIndianNumber(btInitialFoamInvestment), formatIndianNumber(fdInitialFoamInvestment), t("$")],
                    [t("Concentrate used per test"), formatIndianNumber(btConcentrateUsedPerTest), formatIndianNumber(fdConcentrateUsedPerTest), t("gal")],
                    [t("Premix generated per test"), formatIndianNumber(btPremixGeneratedPerTest), formatIndianNumber(fdPremixGeneratedPerTest), t("gal")],
                    [t("Concentrate cost per test"), formatIndianNumber(btConcentrateCostPerTest), formatIndianNumber(fdConcentrateCostPerTest), t("")],
                    [t("Premix disposal cost per test"), formatIndianNumber(btPremixDisposalCostPerTest), formatIndianNumber(fdPremixDisposalCostPerTest), t("")],
                    [t("Work cost per test"), formatIndianNumber(btWorkCostPerTest), formatIndianNumber(fdWorkCostPerTest), t("")],
                    [t("Total cost of proportioning rate test"), formatIndianNumber(btTotalCostOfProportioningRateTest), formatIndianNumber(fdTotalCostOfProportioningRateTest), t("")],
                ]
            },
            {
                title: t("Total Cost of Operation"),
                columns: [t("Cost Item"), "Bladder Tank", 'FireDos'],
                data: [
                    [t("Initial foam investment"), t("$") + formatIndianNumber(btTotalCostOfOperationInitialInvestmentCost), t("$") + formatIndianNumber(fdTotalCostOfOperationInitialInvestmentCost)],
                    [t("Cost of proportioning rate test"), t("$") + formatIndianNumber(btTotalCostOfOperationCostOfProportioningRateTest), t("$") + formatIndianNumber(fdTotalCostOfOperationCostOfProportioningRateTest)],
                    [t("5 year total cost of operation"), t("$") + formatIndianNumber(btTotalCostOfOperation5YearTotalCostOfOperation), t("$") + formatIndianNumber(fdTotalCostOfOperation5YearTotalCostOfOperation)],
                ]
            }, 
            {
                title: "",
                columns: [],
                data: []
            },
            { 
                title: t("Total cost of operation development"),
                columns: [t("Year"), "Bladder Tank", 'FireDos'],
                data: [
                    [t("0"), t("$") + formatIndianNumber(chartBladderTankZeroYear), t("$") + formatIndianNumber(chartFireDosZeroYear)],
                    [t("1"), t("$") + formatIndianNumber(chartBladderTankFirstYear), t("$") + formatIndianNumber(chartFireDosFirstYear)],
                    [t("2"), t("$") + formatIndianNumber(chartBladderTankSecondYear), t("$") + formatIndianNumber(chartFireDosSecondYear)],
                    [t("3"), t("$") + formatIndianNumber(chartBladderTankThirdYear), t("$") + formatIndianNumber(chartFireDosThirdYear)],
                    [t("4"), t("$") + formatIndianNumber(chartBladderTankFour), t("$") + formatIndianNumber(chartFireDosFour)],
                    [t("5"), t("$") + formatIndianNumber(chartBladderTankFive), t("$") + formatIndianNumber(chartFireDosFive)],
                ]
            },

            {
                title: t("Cost Recovery FireDos"),
                columns: [t("Cost Benefit FireDos"), t("Cost Recovery FireDos")],
                data: [
                    [t("$") + formatIndianNumber(chartSecondDiffZeroYear), formatIndianNumber(chartSecondPercentageZeroYear) + "%"],
                    [t("$") + formatIndianNumber(chartSecondDiffFirstYear), formatIndianNumber(chartSecondPercentageFirstYear) + "%"],
                    [t("$") + formatIndianNumber(chartSecondDiffSecondYear), formatIndianNumber(chartSecondPercentageSecondYear) + "%"],
                    [t("$") + formatIndianNumber(chartSecondDiffThirdYear), formatIndianNumber(chartSecondPercentageThirdYear) + "%"],
                    [t("$") + formatIndianNumber(chartSecondDiffFour), formatIndianNumber(chartSecondPercentageFour) + "%"],
                    [t("$") + formatIndianNumber(chartSecondDiffFive), formatIndianNumber(chartSecondPercentageFive) + "%"],
                ]
            },
        ];

        let startY = 13 + textY; // Starting position for the tables
        const marginRight = 15; // Right margin for "Created on"
        const today = new Date();
        const formattedDate = `${today.getDate().toString().padStart(2, '0')}.${(today.getMonth() + 1).toString().padStart(2, '0')}.${today.getFullYear()}`;
        const createdOnTextEng = `Created on ${formattedDate}`; // Dynamic Date
        const createdOnTextDe = `Erstellt am ${formattedDate}`; // Dynamic Date
        tables.forEach((table, index) => {
            startY += 16;
            if(table.title) {
                doc.setFillColor(255, 0, 0); // Red color
                doc.rect(15, startY - 3.3, 4, 4, "F"); // (x, y, width, height, "F" for filled)
    
                // Add table title next to the red square
                doc.setFontSize(12);
                doc.setFont("helvetica", "bold");
                doc.text(table.title, 20, startY); // Adjust text position
            }
            // Draw red square before the title

            if (index === 0) {
                doc.setFontSize(10);
                doc.setFont("helvetica", "bold");
                if (selectLangues === "en") {
                    const createdOnX = pageWidth - doc.getTextWidth(createdOnTextEng) - marginRight;
                    doc.text(createdOnTextEng, createdOnX, startY); // Position on right side
                }
                else {
                    const createdOnX = pageWidth - doc.getTextWidth(createdOnTextDe) - marginRight;
                    doc.text(createdOnTextDe, createdOnX, startY); // Position on right side
                }
            }

            if(table.title) {
                doc.autoTable({
                    head: [table.columns],
                    body: table.data,
                    startY: startY + 5,
                    styles: {
                        cellPadding: 1,
                        lineColor: [0, 0, 0],
                        lineWidth: 0.1,
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        fillColor: [255, 255, 255],
                    },
                    headStyles: {
                        textColor: [33, 37, 41],
                        fillColor: [248, 249, 250],
                        fontStyle: "bold",
                    },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    tableLineColor: [180,180,180], 
                    tableLineWidth: 0.75,
                });
            }
            else {
                doc.autoTable({
                    head: [table.columns],
                    body: table.data,
                    startY: startY + 5,
                    styles: {
                        cellPadding: 1,
                        lineColor: [0, 0, 0],
                        lineWidth: 0.1,
                        fontSize: 10,
                        textColor: [0, 0, 0],
                        fillColor: [255, 255, 255],
                    },
                    headStyles: {
                        textColor: [33, 37, 41],
                        fillColor: [248, 249, 250],
                        fontStyle: "bold",
                    },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    }
                });
            }

            startY = doc.lastAutoTable.finalY + 4;
        });

        // RGB color for footer

        // Footer background (First Page)
        doc.setFillColor(...footerColor);
        doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");

        // Footer text (First Page)
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "bold");

        if (selectLangues === "en") {

            doc.text([
                "www.firedos.com"
            ], 160, pageHeight - 5,);
        } else {
            doc.text([
                "www.firedos.de",
            ], 160, pageHeight - 5,);
        }
        // Add charts
        const canvas = await html2canvas(chartRef.current, { scale: 4 }); // You can increase the scale to 2 or 3 for better quality
        const canvas2 = await html2canvas(chartRef2.current, { scale: 4 });
        const imgData = canvas.toDataURL("image/svg", 4);
        const imgData2 = canvas2.toDataURL("image/svg", 4);

        doc.addImage(imgData, "SVG", 15, startY + 5, 180, 110);
        doc.setDrawColor(180,180,180);
        doc.setLineWidth(0.8);
        doc.rect(14, startY + 5, 182, 110);
        doc.addPage();

        // Footer background (First Page)
        doc.setFillColor(...footerColor);
        //    doc.rect(0, 120,pageWidth , footerHeight, "F");
        doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");

        // Footer text (First Page)
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);

        if (selectLangues === "en") {
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text([
                "Contact Detalis:",
            ], 10, pageHeight - 172,);

            doc.text([
                "USA:",
            ], 10, pageHeight - 155,);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text([
                "FireDos US Inc",
                "9000 Hempstead Rd Ste 280",
                "Houston, TX 77008",
                "United States of America",
                "Phone: +1 346 262 6075",
                "Email: info@firedos.com",
            ], 10, pageHeight - 150,);

            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text([
                "FireDos Middle East:",
            ], 10, pageHeight - 105,);

 
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text([
                "FireDos GmbH",
                "Office 114, Incubator Building",
                "Masdar City ", 
                "Abu Dhabi",
                "United Arab Emirates",
                "Phone: +971 58 133 7464",
                "Email: stuart.phythian@firedos.de",
            ], 10, pageHeight - 100,);


            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text([
                "Germany:",
            ], 10, pageHeight - 55,);

            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text([
                "FireDos GmbH:",
                "Auf der Kaulbahn 6",
                "61200 Woelfersheim",
                "Germany",
                "Phone: +49 6036 9796-0",
                "Email: info@firedos.de"
            ], 10, pageHeight - 50,);
        } else {
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text([
                "Kontakt",
            ], 10, pageHeight - 172,);

            // doc.text([
            //     "USA:",
            // ], 10, pageHeight - 153,);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");

            doc.text([
                "FireDos GmbH",
                "Auf der Kaulbahn 6",
                "61200 Wölfersheim",
                "Deutschland",
                "Tel.: +49 6036 9796-0",
                "E-Mail: info@firedos.de"
            ], 10, pageHeight - 163,);

        }

        if (selectLangues === "en") {
            doc.setFont("helvetica", "bold");
            doc.text([
                "www.firedos.com"
            ], 160, pageHeight - 5,);
        } else {
            doc.text([
                "www.firedos.de",
            ], 160, pageHeight - 5,);
        }
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(t("Cost Recovery FireDos"), 15, 10);
        doc.addImage(imgData2, "SVG", 15, 20, 180, 80); // Adjust position and size as needed
        doc.setDrawColor(180,180,180);
        doc.setLineWidth(0.8);
        doc.rect(14, 20, 182, 80);

        // Save the PDF
        if (selectLangues === "en") {
            doc.save("CALCULATOR-FOR-EXTINGUISHING-SYSTEMS.pdf");
        }
        else {
            doc.save("LÖSCHANLAGEN-KALKULATOR.pdf");
        }
    }; 


    return (
        <Container>
            <Row>
                <Col className='d-flex justify-content-end'>
                    <div className='label-font pointer' style={{ color: selectLangues === "en" ? "red" : "" }} onClick={() => {
                        if(selectLangues !== "en") {
                            changeLanguage("en");
                            setLanguageCounter(languageCounter + 1);
                        }
                    }} ><b>EN</b></div>
                    <div className='mx-1'> | </div>
                    <div className='label-font pointer' style={{ color: selectLangues === "de" ? "red" : "" }} onClick={() => {
                        if(selectLangues !== "de") {
                            changeLanguage("de");
                            setLanguageCounter(languageCounter + 1);
                        }
                    }}><b>DE</b></div>
                </Col>
            </Row>
            <Row ref={contentRef} className=''>
                <Col lg={7}>
                    <div className='mt-1 scroll_set'>
                        <Card>
                            <Card.Body>
                                <h2 className='redDots my-3 ms-1 font-familiy-set title-set-size'>{t("FIRE SUPPRESSION SYSTEM CALCULATOR")}</h2>
                                <div className=''>
                                    <Accordion defaultActiveKey="0" className='mt-4'>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={() => handleToggle("0")}>
                                                <div className='blackDots w-100 d-flex '>
                                                    <div className="title-font d-flex justify-content-between align-items-center  w-100">
                                                        <p className='sub-title-set-size'>{t("System Parameters")}</p>
                                                        {activeKey === "0" ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className='p-2'>
                                                    <Row className='d-none d-sm-flex borderset table-heading py-2'>
                                                        <Col xs={6} sm={3} md={3} lg={4}><p className='m-0 label-set-size'>{t("Parameter")}</p></Col>
                                                        <Col xs={6} sm={3} md={3} lg={3}><p className='m-0 label-set-size'> {t("Bladder Tank")}</p></Col>
                                                        <Col xs={6} sm={3} md={3} lg={3}><p className='m-0 label-set-size'>FireDos	</p></Col>
                                                        <Col xs={6} sm={3} md={3} lg={2}><p className='m-0 label-set-size'>{t("Unit")}</p></Col>
                                                    </Row>
                                                    <div className=''>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("rate")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btConcentrate}
                                                                    onChange={(e) => setBtConcentrate(e.target.value)}
                                                                    onBlur={() => setBtConcentrate(convertNumberForChangeTab(btConcentrate))}
                                                                    className='inputPlaceHolder'
                                                                    >
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdConcentrate}
                                                                    onChange={(e) => setFdConcentrate(e.target.value)}
                                                                    onBlur={() => setFdConcentrate(convertNumberForChangeTab(fdConcentrate))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>%</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Extinguishing time")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btExtinguishingTime}
                                                                    onChange={(e) => setBtExtinguishingTime(e.target.value)}
                                                                    onBlur={() => setBtExtinguishingTime(convertNumberForChangeTab(btExtinguishingTime))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdExtinguishingTime}
                                                                    onChange={(e) => setFdExtinguishingTime(e.target.value)}
                                                                    onBlur={() => setFdExtinguishingTime(convertNumberForChangeTab(fdExtinguishingTime))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("min")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Water flow")}	</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btWaterFlow}
                                                                    onChange={(e) => setBtWaterFlow(e.target.value)}
                                                                    onBlur={() => setBtWaterFlow(convertNumberForChangeTab(btWaterFlow))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdWaterFlow}
                                                                    onChange={(e) => setFdWaterFlow(e.target.value)}
                                                                    onBlur={() => setFdWaterFlow(convertNumberForChangeTab(fdWaterFlow))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("gal/min")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Proportioning test time")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btProportioningTestTime}
                                                                    onChange={(e) => setBtProportioningTestTime(e.target.value)}
                                                                    onBlur={() => setBtProportioningTestTime(convertNumberForChangeTab(btProportioningTestTime))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdProportioningTestTime}
                                                                    onChange={(e) => setFdProportioningTestTime(e.target.value)}
                                                                    onBlur={() => setFdProportioningTestTime(convertNumberForChangeTab(fdProportioningTestTime))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("min")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Personnel required for proportioning test")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btpersonnelRequired}
                                                                    onChange={(e) => setBtpersonnelRequired(e.target.value)}
                                                                    onBlur={() => setBtpersonnelRequired(convertNumberForChangeTab(btpersonnelRequired))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdpersonnelRequired}
                                                                    onChange={(e) => setFdpersonnelRequired(e.target.value)}
                                                                    onBlur={() => setFdpersonnelRequired(convertNumberForChangeTab(fdpersonnelRequired))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("ea")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Work time proportioning test")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btworkTime}
                                                                    onChange={(e) => setBtworkTime(e.target.value)}
                                                                    onBlur={() => setBtworkTime(convertNumberForChangeTab(btworkTime))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdworkTime}
                                                                    onChange={(e) => setFdworkTime(e.target.value)}
                                                                    onBlur={() => setFdworkTime(convertNumberForChangeTab(fdworkTime))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("hour")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Labor cost")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btlaborCost}
                                                                    onChange={(e) => setBtlaborCost(e.target.value)}
                                                                    onBlur={() => setBtlaborCost(convertNumberForChangeTab(btlaborCost))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdlaborCost}
                                                                    onChange={(e) => setFdlaborCost(e.target.value)}
                                                                    onBlur={() => setFdlaborCost(convertNumberForChangeTab(fdlaborCost))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Concentrate cost")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btconCentrateCost}
                                                                    onChange={(e) => setBtConcentrateCost(e.target.value)}
                                                                    onBlur={() => setBtConcentrateCost(convertNumberForChangeTab(btconCentrateCost))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdconCentrateCost}
                                                                    onChange={(e) => setFdConcentrateCost(e.target.value)}
                                                                    onBlur={() => setFdConcentrateCost(convertNumberForChangeTab(fdconCentrateCost))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}/{t("Gal")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Premix disposal cost")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btPremix}
                                                                    onChange={(e) => setBtpremix(e.target.value)}
                                                                    onBlur={() => setBtpremix(convertNumberForChangeTab(btPremix))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdPremix}
                                                                    onChange={(e) => setFdpremix(e.target.value)}
                                                                    onBlur={() => setFdpremix(convertNumberForChangeTab(fdPremix))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}/{t("Gal")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Annual regular maintenance cost")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btRegularMaintenance}
                                                                    onChange={(e) => setBtregularMaintenance(e.target.value)}
                                                                    onBlur={() => setBtregularMaintenance(convertNumberForChangeTab(btRegularMaintenance))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdRegularMaintenance}
                                                                    onChange={(e) => setFdregularMaintenance(e.target.value)}
                                                                    onBlur={() => setFdregularMaintenance(convertNumberForChangeTab(fdRegularMaintenance))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Bladder / foam tank size needed")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={formatIndianNumber(btTankSizeNeeded)}
                                                                    disabled
                                                                    className='inputPlaceHolder inputGreenPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={formatIndianNumber(fdTankSizeNeeded)}
                                                                    disabled
                                                                    className='inputPlaceHolder inputGreenPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("gal")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("Cost bladder / foam tank")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btFoamTank}
                                                                    onChange={(e) => setBtFoamTank(e.target.value)}
                                                                    onBlur={() => setBtFoamTank(convertNumberForChangeTab(btFoamTank))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdFoamTank}
                                                                    onChange={(e) => setFdFoamTank(e.target.value)}
                                                                    onBlur={() => setFdFoamTank(convertNumberForChangeTab(fdFoamTank))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("One-off cost bladder tank proportioner")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={btTankProportioner}
                                                                    onChange={(e) => seTBttankProportioner(e.target.value)}
                                                                    onBlur={() => seTBttankProportioner(convertNumberForChangeTab(btTankProportioner))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Parameter")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='regular-font-set'>{t("One-off Cost firedos proportioner")}</p></Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>
                                                                <input
                                                                    type='text'
                                                                    value={fdfiredosProportioner}
                                                                    onChange={(e) => seTFdFiredosProportioner(e.target.value)}
                                                                    onBlur={() => seTFdFiredosProportioner(convertNumberForChangeTab(fdfiredosProportioner))}
                                                                    className='inputPlaceHolder'>
                                                                </input>
                                                            </Col>
                                                            <Col className='d-block d-sm-none fw-bold mt-2 label-set-size' xs={12}><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                    <Accordion className='my-2'>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header onClick={() => handleToggle("1")}>
                                                <div className='blackDots w-100 d-flex '>
                                                    <div className="title-font d-flex justify-content-between align-items-center  w-100">
                                                        <p className='sub-title-set-size'>    {t("Test Costs - Detailed View")}</p>
                                                        {activeKey === "1" ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                    <Row className='d-none d-sm-flex borderset table-heading py-2'>
                                                        <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 label-set-size'>{t("Cost Item")}</p></Col>
                                                        <Col xs={12} sm={3} md={3} lg={3}><p className='m-0 label-set-size'>{t("Bladder Tank")}	</p></Col>
                                                        <Col xs={12} sm={3} md={3} lg={3}><p className='m-0 label-set-size'>FireDos	</p></Col>
                                                        <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 label-set-size'>{t("Unit")}</p></Col>
                                                    </Row>
                                                    <div className=''>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Initial foam investment")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(btInitialFoamInvestment)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdInitialFoamInvestment)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Concentrate used per test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(btConcentrateUsedPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdConcentrateUsedPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("gal")} </p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Premix generated per test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(btPremixGeneratedPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdPremixGeneratedPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("gal")} </p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Concentrate cost per test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(btConcentrateCostPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdConcentrateCostPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Premix disposal cost per test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(btPremixDisposalCostPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdPremixDisposalCostPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Work cost per test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(btWorkCostPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdWorkCostPerTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Total cost of proportioning rate test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>	{formatIndianNumber(btTotalCostOfProportioningRateTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={3}>{formatIndianNumber(fdTotalCostOfProportioningRateTest)}</Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size'><p className='m-0'>{t("Unit")}</p></Col>
                                                            <Col xs={12} sm={3} md={3} lg={2}><p className='m-0 labe-font regular-font-set'>{t("$")}</p></Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                    <Accordion>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header onClick={() => handleToggle("2")}>
                                                <div className='blackDots w-100 d-flex '>
                                                    <div className="title-font d-flex justify-content-between align-items-center  w-100">
                                                        <p className='sub-title-set-size'>{t("Total Cost of Operation")}</p>
                                                        {activeKey === "2" ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                    <Row className=' d-none d-sm-flex borderset table-heading py-2'>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Cost Item")}</p></Col>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Bladder Tank")}	</p></Col>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>FireDos	</p></Col>
                                                    </Row>
                                                    <div className=''>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 labe-font regular-font-set '>{t("Initial investment cost")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(btTotalCostOfOperationInitialInvestmentCost)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(fdTotalCostOfOperationInitialInvestmentCost)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 labe-font regular-font-set'>{t("Cost of proportioning rate test")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(btTotalCostOfOperationCostOfProportioningRateTest)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(fdTotalCostOfOperationCostOfProportioningRateTest)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Item")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 labe-font regular-font-set'>{t("5 year total cost of operation")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(btTotalCostOfOperation5YearTotalCostOfOperation)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(fdTotalCostOfOperation5YearTotalCostOfOperation)} </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                    <Accordion>
                                        <Accordion.Item eventKey="3" className='my-2'>
                                            <Accordion.Header onClick={() => handleToggle("3")}>
                                                <div className='blackDots w-100 d-flex '>
                                                    <div className="title-font d-flex justify-content-between align-items-center  w-100">
                                                        <p className='sub-title-set-size'>{t("TOTAL COST OF OPERATION DEVELOPMENT")}</p>
                                                        {activeKey === "3" ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                    <Row className='borderset d-none d-sm-flex table-heading py-2'>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Year")}</p></Col>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Bladder Tank")}	</p></Col>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>FireDos	</p></Col>
                                                    </Row>
                                                    <div className=''>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("0")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartBladderTankZeroYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartFireDosZeroYear)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set'>{t("1")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartBladderTankFirstYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartFireDosFirstYear)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set'>{t("2")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartBladderTankSecondYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartFireDosSecondYear)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set'>{t("3")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartBladderTankThirdYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartFireDosThirdYear)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set'>{t("4")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartBladderTankFour)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartFireDosFour)} </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set'>{t("5")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Bladder Tank")}	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartBladderTankFive)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>FireDos	</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}>{t("$")}{formatIndianNumber(chartFireDosFive)} </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                    <Accordion>
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header onClick={() => handleToggle("4")}>
                                                <div className='blackDots w-100 d-flex '>
                                                    <div className="title-font d-flex justify-content-between align-items-center  w-100">
                                                        <p className='sub-title-set-size'>{t("COST RECOVERY FIREDOS")}</p>
                                                        {activeKey === "4" ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                    <Row className='borderset d-none d-sm-flex table-heading py-2'>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Year")}</p></Col>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Cost Benefit FireDos")}</p></Col>
                                                        <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 label-set-size'>{t("Cost Recovery FireDos")}</p></Col>
                                                    </Row>
                                                    <div className=''>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("0")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Benefit FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartSecondDiffZeroYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Recovery FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{formatIndianNumber(chartSecondPercentageZeroYear)} % </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("1")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Benefit FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartSecondDiffFirstYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Recovery FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{formatIndianNumber(chartSecondPercentageFirstYear)} % </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("2")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Benefit FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartSecondDiffSecondYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Recovery FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{formatIndianNumber(chartSecondPercentageSecondYear)} % </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("3")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Benefit FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartSecondDiffThirdYear)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Recovery FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{formatIndianNumber(chartSecondPercentageThirdYear)} % </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("4")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Benefit FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartSecondDiffFour)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Recovery FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{formatIndianNumber(chartSecondPercentageFour)} % </Col>
                                                        </Row>
                                                        <Row className='py-2 border-top'>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Year")}</p></Col>
                                                            <Col xs={12} sm={4} md={4} lg={4}><p className='m-0 regular-font-set '>{t("5")}</p></Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Benefit FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{t("$")}{formatIndianNumber(chartSecondDiffFive)} </Col>
                                                            <Col xs={12} className='d-block d-sm-none fw-bold label-set-size' ><p className='m-0'>{t("Cost Recovery FireDos")}	</p></Col>
                                                            <Col xs={4} lg={4} className='regular-font-set'>{formatIndianNumber(chartSecondPercentageFive)} % </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div> 
                            </Card.Body>
                        </Card>
                    </div>
                </Col> 
                <Col lg={5} className=''>
                    <div className='mt-1'>
                        <Card>
                            <Card.Body>
                                <h2 className='redDots title-set-size'>{t("TOTAL COST OF OPERATION DEVELOPMENT")}</h2>
                                <LineChart formatIndianNumber={formatIndianNumber} selectLangues={selectLangues} ref={chartRef} firstChartArrayData={firstChartArrayData} />
                                <div className='my-5'></div>
                                <h2 className='redDots title-set-size'>{t("COST RECOVERY FIREDOS")}</h2>
                                <LineChartCostRevovery ref={chartRef2} secondchartArrayData={secondchartArrayData} />
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='d-flex justify-content-end my-2 '>
                        <div className='mx-2'>
                            <Button className="Explanation" onClick={() => handleShow()}>{t("Explanation")}</Button>
                        </div>
                        <Button className="ExportPdf" onClick={() => generatePDF()}>{t("Export Pdf")}</Button>
                    </div>
                </Col>
            </Row>
            <ModelInfo lng={selectLangues} show={show} handleClose={handleClose} />
        </Container>
    );
};

export default FireSuppressionCalculator; 